module.exports = __webpack_public_path__ + "img/Body_Normal.1819fd2.png";